/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import BrowserDetection from 'services/BrowserDetection';

const DEFAULT_DEBOUNCE_WAIT = BrowserDetection.isIE() ? 1000 : 300;

export default DEFAULT_DEBOUNCE_WAIT;